module.exports = __webpack_public_path__ + "static/media/DRAMA.57f323c2.png";